document.addEventListener('DOMContentLoaded', () => {

    const isHome = document.querySelector('.home');

    if (isHome) {
        gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

        /* Main navigation */
        let panelsSection = document.querySelector("#panels"),
            panelsContainer = document.querySelector("#panels-container"),
            tween;
        let panelsSectionTech = document.querySelector("#panels-technologia"),
            panelsContainerTech = document.querySelector("#panels-container-technologia"),
            tweenTech;
        let panelsSectionRozwBiz = document.querySelector("#panels-rozwoj-biznesu"),
            panelsContainerRozwBiz = document.querySelector("#panels-container-rozwoj-biznesu"),
            tweenRozwBiz;
            
        document.querySelectorAll(".anchor").forEach(anchor => {
            anchor.addEventListener("click", function (e) {
                console.log('registered anchor')
                e.preventDefault();
                let targetElem = document.querySelector(e.target.getAttribute("href")),
                    y = targetElem;
                if (targetElem && panelsContainer.isSameNode(targetElem.parentElement)) {
                    let totalScroll = tween.scrollTrigger.end - tween.scrollTrigger.start,
                        totalMovement = (panels.length - 1) * targetElem.offsetWidth;
                    y = Math.round(tween.scrollTrigger.start + (targetElem.offsetLeft / totalMovement) *
                        totalScroll);
                }
    
                if (targetElem && panelsContainerTech.isSameNode(targetElem.parentElement)) {
                    let totalScroll = tweenTech.scrollTrigger.end - tweenTech.scrollTrigger.start,
                        totalMovement = (panels.length - 1) * targetElem.offsetWidth;
                    y = Math.round(tweenTech.scrollTrigger.start + (targetElem.offsetLeft / totalMovement) *
                        totalScroll);
                }
    
                if (targetElem && panelsContainerRozwBiz.isSameNode(targetElem.parentElement)) {
                    let totalScroll = tweenRozwBiz.scrollTrigger.end - tweenRozwBiz.scrollTrigger.start,
                        totalMovement = (panels.length - 1) * targetElem.offsetWidth;
                    y = Math.round(tweenRozwBiz.scrollTrigger.start + (targetElem.offsetLeft / totalMovement) *
                        totalScroll);
                }
    
                gsap.to(window, {
                    scrollTo: {
                        y: y,
                        autoKill: false
                    },
                    duration: 0.1
                });
            });
        });
    
        
            
            const panels = gsap.utils.toArray("#panels-container .panel");
            const panelsTech = gsap.utils.toArray("#panels-container-technologia .panel");
            const panelsRozwBiz = gsap.utils.toArray("#panels-container-rozwoj-biznesu .panel");
    
            if (window.innerWidth >= 768) {
    
            /* Panels */
            tween = gsap.to(panels, { 
                xPercent: -100 * (panels.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: "#panels-container",
                    pin: true,
                    start: "top top",
                    scrub: 1,
                    // snap: {
                    //     snapTo: 1 / (panels.length - 1),
                    //     inertia: false,
                    //     duration: {
                    //         min: 0.1,
                    //         max: 0.1
                    //     }
                    // },
                    end: () => "+=" + (panelsContainer.offsetWidth - innerWidth)
                }
            });
    
            /* Panels Tech*/
            
            tweenTech = gsap.to(panelsTech, {
                xPercent: -100 * (panelsTech.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: "#panels-container-technologia",
                    pin: true,
                    start: "top top",
                    scrub: 1,
                    // snap: {
                    //     snapTo: 1 / (panelsTech.length - 1),
                    //     inertia: false,
                    //     duration: {
                    //         min: 0.1,
                    //         max: 0.1, 
                    //     }
                    // },
                    end: () => "+=" + (panelsContainerTech.offsetWidth - innerWidth)
                }
            });
    
            /* Panels RozwBiz*/
            
            tweenRozwBiz = gsap.to(panelsRozwBiz, {
                xPercent: -100 * (panelsRozwBiz.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: "#panels-container-rozwoj-biznesu",
                    pin: true,
                    start: "top top",
                    scrub: 1,
                    // snap: {
                    //     snapTo: 1 / (panelsRozwBiz.length - 1),
                    //     inertia: false,
                    //     duration: {
                    //         min: 0.1,
                    //         max: 0.1, 
                    //     }
                    // },
                    end: () => "+=" + (panelsContainerRozwBiz.offsetWidth - innerWidth)
                }
            });
        }
    }
    
})
